export default __webpack_public_path__ + "static/media/icon_arrow.59b289c0.svg";